import { lazy } from 'react'

import MyProfileLoader from './loader'

export default {
  MyProfile: {
    Component: lazy(() => import('./MyProfile.Page')),
    Loader: MyProfileLoader,
  },
}
